// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/scan-search.js';

import { paths } from '../generated/scan-search';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('scan-search', Original, paths);
